
import TransferDom from 'vux/src/directives/transfer-dom/index.js'

import {sendcommandmessage} from '../../api/device'

export default {
name: 'childDevice901',
directives: {
TransferDom
},
data () {
return {
deviceData: '',
openShow: false,
openTitle: '',
openIndex: '',

sosPhone: {
phone1: '',
phone2: '',
phone3: ''
},

showfallDownRadio: '',
fallDownRadio: 1,
fallDown: 50,

showBluetooth: '',
bluetooth: 1,
bluetoothObj: {
interval: '',
time: '',
filtration: ''
},

alarmClockShow: '',
dayArr: [{text: '01'}, {text: '02'}, {text: '03'}, {text: '04'}, {text: '05'}, {text: '06'}, {text: '07'}, {text: '08'}, {text: '09'}, {text: '10'}, {text: '11'}, {text: '12'}, {text: '13'}, {text: '14'}, {text: '15'},
{text: '16'}, {text: '17'}, {text: '18'}, {text: '19'}, {text: '20'}, {text: '21'}, {text: '22'}, {text: '23'}, {text: '24'}, {text: '25'}, {text: '26'}, {text: '27'}, {text: '28'}, {text: '29'}, {text: '30'}, {text: '31'}],

showDayPicker: false,
dTime: '',
dTimeIndex: 0,

showMonthTime: false,
mTime: '',
mTimeInfo: new Date(),

showYearTime: false,
yTime: '',
yTimeInfo: new Date(),
minDate: new Date(2020, 0, 1),
showCurrentTime: false,

currentTime: '',
alarmClock: {
type: 'pill',
period: 'y',
content: ''
},
showPicker: false,
valueType: '',
valueTypeIndex: 0,
showPicker1: false,
valueTime: '按年',
valueTimeIndex: 0,
clockPeriodModelArr: [{text: '按年', value: 'y'}, {text: '按月', value: 'm'}, {text: '按天', value: 'd'}, {text: '只提醒一次', value: 's'}],
clockContentTypeArr: [{text: '吃药提醒', value: 'pill'}, {text: '量血压', value: 'BP'}, {text: '测体温', value: 'Temp'}, {text: '测血糖', value: 'GLU'}, {text: '体检', value: 'PE'}, {text: '其它', value: 'other'}],

voiceRadio: '1',
textVoice: '',

locationRadio: '1',
location1: -1,
location2: 2,
showPicker22: false,
valueModel2: '',
valueModel2Index: 0,
showPicker2: false,
valueModel: '',
valueModelIndex: 0,
modelArr: [{text: '基站', id: 1}, {text: 'wifi', id: 2}, {text: 'GPS', id: 3}, {text: '自动高精度', id: 4}, {text: '自动最快', id: 5}],
showStartTime: false,
startTime: '',
showEndTime: false,
endTime: '',
minHour: '00',
locationObj: {
timeDate: '',
num: '',
time: '',
time2: '',
selectModel: '',
selectModel2: ''
},

indoor: '',
indoorObj: {
model: '',
type: '',
symbol: '',
interval: '',
time: ''
},
showPicker3: false,
valueModel3: '',
valueModel3Index: 0,
locationModelArr: [{text: 'wifi', id: 1}, {text: '蓝牙', id: 2}],
doorType: '',
doorTypeIndex: 0,
showPicker4: false,
typeArr: [{text: 'ssid', id: 1}, {text: 'mac', id: 2}],

showRecordDuration: false,
recordDuration: '',
recordDurationIndex: 0,
selectRecord: '',
recordArr: [{text: '10秒', id: 10}, {text: '20秒', id: 20}, {text: '30秒', id: 30}, {text: '一分钟', id: 60}],
record: {
duration: ''
}
}
},
created () {
this.deviceData = this.$store.getters.get_child_obj
console.log(901, this.deviceData.setting)
this.getStartData()

Date.prototype.format = this.validate.format
let y = new Date().format('yyyy')
let m = new Date().format('M')
let d = new Date().format('dd')
let strings = this.mTime.split('-')
this.mTimeInfo = new Date(y, parseInt(strings[0]) - 1, strings[1])
this.minDate = new Date(y, m - 1, d)

},
methods: {

getStartData () {
this.deviceData = this.$store.getters.get_child_obj
let arr = this.deviceData.setting
for (let i = 0; i < arr.length; i++) {
let startObj = ''
if (arr[i].other !== '') {
startObj = JSON.parse(arr[i].other)
}
if (arr[i].func === 'community') {
this.sosPhone.phone1 = startObj.command1
this.sosPhone.phone2 = startObj.command2
this.sosPhone.phone3 = startObj.command3
} else if (arr[i].func === 'falldown') {

this.showfallDownRadio = parseInt(startObj.command1)
this.fallDownRadio = parseInt(startObj.command1)
this.fallDown = parseInt(startObj.command2)
} else if (arr[i].func === 'bluetoothswitch') {

this.showBluetooth = parseInt(startObj.command1)
this.bluetooth = parseInt(startObj.command1)
this.bluetoothObj.interval = startObj.command2
this.bluetoothObj.time = startObj.command3
this.bluetoothObj.filtration = startObj.command4
} else if (arr[i].func === 'setclock') {

this.alarmClock.period = startObj.command1
for (let j = 0; j < this.clockPeriodModelArr.length; j++) {
if (startObj.command1 === this.clockPeriodModelArr[j].value) {
this.valueTime = this.clockPeriodModelArr[j].text
this.valueTimeIndex = j
}
}
for (let j = 0; j < this.clockContentTypeArr.length; j++) {
if (startObj.command3 === this.clockContentTypeArr[j].value) {
this.valueType = this.clockContentTypeArr[j].text
this.valueTypeIndex = j
}
}

let command2 = startObj.command2.split(' ')
if (this.alarmClock.period === 'y') {
this.mTime = command2[0]

Date.prototype.format = this.validate.format
let y = new Date().format('yyyy')
this.mTimeInfo = new Date(y + '-' + command2[0])
this.currentTime = command2[1].slice(0, 5)
this.alarmClockShow = '每年' + startObj.command2
} else if (this.alarmClock.period === 'm') {
this.dTime = command2[0]
for (let j = 0; j < this.dayArr.length; j++) {
if (this.dTime === this.dayArr[j].text) {
this.dTimeIndex = j
}
}
this.currentTime = command2[1].slice(0, 5)
this.alarmClockShow = '每月' + command2[0] + '号 ' + this.currentTime
} else if (this.alarmClock.period === 'd') {
this.currentTime = command2[0].slice(0, 5)
this.alarmClockShow = '每天' + this.currentTime
} else if (this.alarmClock.period === 's') {
this.yTime = command2[0]
this.yTimeInfo = new Date(command2[0])
this.currentTime = command2[1].slice(0, 5)
this.alarmClockShow = startObj.command2
}
let isNo = true
for (let j = 0; j < this.clockContentTypeArr.length; j++) {
if (this.clockContentTypeArr[j].value === startObj.command3) {
this.alarmClock.type = startObj.command3
isNo = false
}
}
if (isNo) {
this.alarmClock.type = 'other'
this.alarmClock.content = startObj.command3
}
} else if (arr[i].func === 'voicemessage') {

this.voiceRadio = startObj.command2
this.textVoice = startObj.command3
} else if (arr[i].func === 'requirelocation') {

this.location1 = parseInt(startObj.command1)
this.locationObj.num = startObj.command2
this.locationObj.time = startObj.command3
this.locationObj.selectModel = parseInt(startObj.command4)
for (let j = 0; j < this.modelArr.length; j++) {
if (this.locationObj.selectModel === this.modelArr[j].id) {
this.valueModel = this.modelArr[j].text
this.valueModelIndex = j
}
}
} else if (arr[i].func === 'requirelocationperiod') {
this.location2 = parseInt(startObj.command1)
this.startTime = startObj.command2
this.endTime = startObj.command3
this.locationObj.time2 = startObj.command4
this.locationObj.selectModel2 = parseInt(startObj.command5)
for (let j = 0; j < this.modelArr.length; j++) {
if (this.locationObj.selectModel2 === this.modelArr[j].id) {
this.valueModel2 = this.modelArr[j].text
this.valueModel2Index = j
}
}
} else if (arr[i].func === 'requirelocationinroom') {
this.indoorObj.model = parseInt(startObj.command1)
for (let j = 0; j < this.locationModelArr.length; j++) {
if (parseInt(startObj.command1) === this.locationModelArr[j].id) {
this.valueModel3 = this.locationModelArr[j].text
this.valueModel3Index = j
}
}
this.indoorObj.type = parseInt(startObj.command2)
for (let j = 0; j < this.typeArr.length; j++) {
if (parseInt(startObj.command2) === this.typeArr[j].id) {
this.doorType = this.typeArr[j].text
this.doorTypeIndex = j
}
}
this.indoorObj.symbol = startObj.command3
this.indoorObj.interval = startObj.command4
this.indoorObj.time = startObj.command5
this.indoor = parseInt(startObj.reserved1)
} else if (arr[i].func === 'recordvoice') {
for (let j = 0; j < this.recordArr.length; j++) {
if (parseInt(startObj.command3) === this.recordArr[j].id) {
this.selectRecord = this.recordArr[j]
this.recordDuration = this.recordArr[j].text
this.recordDurationIndex = j
}
}
}
}
},
onConfirm (obj) {
this.valueType = obj.text
this.alarmClock.type = obj.value
this.showPicker = false
},
onConfirm1 (obj) {
this.valueTime = obj.text
this.alarmClock.period = obj.value
this.showPicker1 = false
},
onConfirm2 (obj) {
this.valueModel = obj.text
this.locationObj.selectModel = obj.id
this.showPicker2 = false
},
onConfirm22 (obj) {
this.valueModel2 = obj.text
this.locationObj.selectModel2 = obj.id
this.showPicker22 = false
},
onConfirm3 (obj) {
this.valueModel3 = obj.text
this.indoorObj.model = obj.id
this.showPicker3 = false
},
onConfirm4 (obj) {
this.doorType = obj.text
this.indoorObj.type = obj.id
this.showPicker4 = false
},
onConfirm5 (time) {
console.log(time)
this.currentTime = time
this.showCurrentTime = false
},
onConfirm6 (time) {
console.log(time)
this.yTime = time.format('yyyy-MM-dd')
this.showYearTime = false
},
formatter (type, val) {
if (type === 'month') {
return `${val}月`
} else if (type === 'day') {
return `${val}日`
}
return val
},
onConfirm7 (time) {
console.log(time)
this.mTime = time.format('MM-dd')
this.showMonthTime = false
},
onConfirm8 (obj) {
console.log(obj)
this.dTime = obj.text
this.showDayPicker = false
},
onConfirm9 (time) {
console.log(time)
this.startTime = time
this.endTime = ''
this.minHour = time.split(':')[0]
this.showStartTime = false
},
onConfirm10 (time) {
console.log(time)
this.endTime = time
this.showEndTime = false
},
onConfirm11 (obj) {
console.log(obj)
this.selectRecord = obj
this.recordDuration = obj.text
this.showRecordDuration = false
},
openWindowShow (index) {
if (index === 1) {
this.openTitle = 'SOS呼叫号码'
} else if (index === 2) {
this.openTitle = '跌倒设置'
} else if (index === 3) {
this.openTitle = '蓝牙功能'
} else if (index === 4) {
this.openTitle = '闹钟提醒'
} else if (index === 5) {
this.openTitle = '语音设置'
} else if (index === 6) {
this.openTitle = '定位设置'
} else if (index === 7) {
this.openTitle = '室内定位'
} else if (index === 8) {
this.openTitle = '录音上传'
} else {
this.openTitle = ''
}
this.openIndex = index
this.openShow = true
},
sendSetDevice () {
let data = {
imei: this.deviceData.deviceid,
did: this.deviceData.id,
method: '',
command1: '',
command2: '',
command3: '',
command4: '',
command5: '',
reserved1: '',
reserved2: ''
}
if (this.openIndex === 1) {
data.method = 'community'
data.command1 = this.sosPhone.phone1 !== '' ? this.sosPhone.phone1 : ''
data.command2 = this.sosPhone.phone2 !== '' ? this.sosPhone.phone2 : ''
data.command3 = this.sosPhone.phone3 !== '' ? this.sosPhone.phone3 : ''
} else if (this.openIndex === 2) {
data.method = 'falldown'
data.command1 = this.fallDownRadio + ''
data.command2 = this.fallDown !== '' ? this.fallDown + '' : ''
} else if (this.openIndex === 3) {
data.method = 'bluetoothswitch'
data.command1 = this.bluetooth + ''
data.command2 = this.bluetoothObj.interval + ''
data.command3 = this.bluetoothObj.time + ''
data.command4 = this.bluetoothObj.filtration + ''
} else if (this.openIndex === 4) {
let time = this.currentTime + ':00'
if (this.alarmClock.period === 'y') {
time = this.mTime + ' ' + this.currentTime + ':00'
} else if (this.alarmClock.period === 'm') {
time = this.dTime + ' ' + this.currentTime + ':00'
} else if (this.alarmClock.period === 'd') {
time = this.currentTime + ':00'
} else if (this.alarmClock.period === 's') {
time = this.yTime + ' ' + this.currentTime + ':00'
}
data.method = 'setclock'
data.command1 = this.alarmClock.period !== '' ? this.alarmClock.period : ''
data.command2 = time
data.command3 = this.alarmClock.type !== 'other' ? this.alarmClock.type : this.alarmClock.content
} else if (this.openIndex === 5) {
data.method = 'voicemessage'
data.command1 = 'voice' 
data.command2 = this.voiceRadio
data.command3 = this.textVoice
} else if (this.openIndex === 6) {
if (this.locationRadio === '1') {

data.method = 'requirelocation'
data.command1 = this.location1 + ''
data.command2 = this.locationObj.num !== '' ? this.locationObj.num + '' : ''
data.command3 = this.locationObj.time !== '' ? this.locationObj.time + '' : ''
data.command4 = this.locationObj.selectModel !== '' ? this.locationObj.selectModel + '' : ''
} else {

data.method = 'requirelocationperiod'
data.command1 = this.location2 + ''
data.command2 = this.startTime
data.command3 = this.endTime
data.command4 = this.locationObj.time2 !== '' ? this.locationObj.time2 + '' : ''
data.command5 = this.locationObj.selectModel2 !== '' ? this.locationObj.selectModel2 + '' : ''
}
} else if (this.openIndex === 7) {
data.method = 'requirelocationinroom'
data.command1 = this.indoorObj.model + ''
data.command2 = this.indoorObj.type + ''
data.command3 = this.indoorObj.symbol + ''
data.command4 = this.indoorObj.interval + ''
data.command5 = this.indoorObj.time + ''
data.reserved1 = this.indoor + ''
} else if (this.openIndex === 8) {
data.method = 'recordvoice'
data.command3 = this.selectRecord.id ? this.selectRecord.id + '' : ''
}


sendcommandmessage(data).then(res => {
if (res.code === 200) {
this.$toast('成功')
this.openShow = false
if (this.openIndex === 2) {
this.showfallDownRadio = this.fallDownRadio
} else if (this.openIndex === 3) {
this.showBluetooth = this.bluetooth
} else if (this.openIndex === 4) {
if (data.command1 === 'y') {
this.alarmClockShow = '每年' + this.mTime + ' ' + this.currentTime + ':00'
} else if (data.command1 === 'm') {
this.alarmClockShow = '每月' + this.dTime + '号 ' + this.currentTime + ':00'
} else if (data.command1 === 'd') {
this.alarmClockShow = '每天' + this.currentTime + ':00'
} else if (data.command1 === 's') {
this.alarmClockShow = this.yTime + ' ' + this.currentTime + ':00'
}
this.alarmClockShow = data.command2
}

let isNo = true
for (let i = 0; i < this.deviceData.setting.length; i++) {
if (this.deviceData.setting[i].func === data.method) {
this.deviceData.setting[i].other = JSON.stringify(data)
isNo = false
}
}
if (isNo) {
let obj = {confirmon: '', func: data.method, other: JSON.stringify(data), seton: '', status: 0, value: 901}
this.deviceData.setting.push(obj)
}
this.$store.commit('set_child_obj', this.deviceData)
} else {
this.$toast('失败')
}
}).catch(() => {
this.$toast('失败')
})
}
}
}



// WEBPACK FOOTER //
// ./src/components/device/childDevice901.vue